import axios from 'axios'
import AuthService from './auth.service'

// Processes the global response interceptors
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      console.log('Interceptor response error: ', error.response)
      if (error.response.status === 401 && !window.location.pathname.includes('/login')) {
        AuthService.logout()
        window.location.href = '/login'
      }
    }

    // Do something with response error
    return error.response
  }
)

export default axios
